import * as THREE from "three";
import { BaseScene } from "./basescene"; // Import BaseScene

class ThreeUtils {

    public static centerGltf(gltf) {
        const box = new THREE.Box3().setFromObject(gltf.scene);
        const center = box.getCenter(new THREE.Vector3());

        gltf.scene.position.x += (gltf.scene.position.x - center.x);
        gltf.scene.position.y += (gltf.scene.position.y - center.y);
        gltf.scene.position.z += (gltf.scene.position.z - center.z);
    }

    public static boudingBox(obj) {
        return this.getBoundingBox(obj);

        if (obj instanceof THREE.Mesh) {
            const geometry = obj.geometry;
            geometry.computeBoundingBox();
            return geometry.boundingBox;
        }

        if (obj instanceof THREE.Object3D) {
            const bb = new THREE.Box3();
            for (let i = 0; i < obj.children.length; i++) {
                bb.union(this.boudingBox(obj.children[i]));
            }
            return bb;
        }
        //        var bb1 = new THREE.BoxHelper(obj, 0xff44ff);

        let me = this;
        var bb1 = this.getBBox(obj);
        return bb1;
    }

    public static shapeCenterOfGravity(obj) {
        var bb = this.boudingBox(obj);
        var result = new THREE.Vector3();

        bb.getCenter(result);
        //     result.multiply(obj.scale);
        //   result.sub(obj.position);
        return result;
    }

    public static pointCameraTo(camera, controls, node) {
        var me = this;
        // Refocus camera to the center of the new object
        var COG = this.shapeCenterOfGravity(node);
        var v = new THREE.Vector3();
        v.subVectors(COG, controls.target);
        camera.position.addVectors(camera.position, v);
        // retrieve camera orientation and pass it to trackball  
        camera.lookAt(COG);
        controls.target.set(COG.x, COG.y, COG.z);
        return COG;
    };

    /**
     *  Zoom to object
     */
    public static zoomObject(camera, controls: any, nodes: THREE.Object3D | THREE.Object3D[], zoomOffsetFactor: number = 1.0) {
        try {
            const bbox = new THREE.Box3();

            // Handle single node or array of nodes
            if (Array.isArray(nodes)) {
                nodes.forEach(node => bbox.expandByObject(node));
            } else {
                bbox.expandByObject(nodes);
            }

            if (bbox.isEmpty()) {
                return;
            }

            const size = new THREE.Vector3();
            bbox.getSize(size);
            const center = bbox.getCenter(new THREE.Vector3());

            // Update controls target to center of bounding box
            controls.target.copy(center);

            if (camera instanceof THREE.OrthographicCamera) {
                // Orthographic camera handling
                const maxDim = Math.max(size.x, size.y, size.z);
                // Apply zoom offset factor to distance
                const distance = maxDim * zoomOffsetFactor;

                // Position camera relative to center
                const dir = new THREE.Vector3().subVectors(camera.position, center).normalize();
                camera.position.copy(center).add(dir.multiplyScalar(distance));

                // Set zoom to fit object, using offset factor to zoom out more
                const zoom = 1.0 / (maxDim / Math.min(camera.right * 2, camera.top * 2)) * (0.8 / zoomOffsetFactor);
                camera.zoom = zoom;
            } else {
                // Perspective camera handling
                const sphereSize = size.length() * 0.5;
                const fov = (camera as THREE.PerspectiveCamera).fov * (Math.PI / 180.0);
                // Apply zoom offset factor to distance
                const distToCenter = sphereSize / Math.sin(fov * 0.5) * zoomOffsetFactor;

                // Position camera
                const dir = new THREE.Vector3().subVectors(camera.position, center).normalize();
                camera.position.copy(center).add(dir.multiplyScalar(distToCenter));
            }

            camera.updateProjectionMatrix();
            controls.update();
        } catch (e) {
            console.warn("zoomObject", e);
        }
    }

    public centerGltf(gltf) {
        const box = new THREE.Box3().setFromObject(gltf.scene);
        const center = box.getCenter(new THREE.Vector3());

        gltf.scene.position.x += (gltf.scene.position.x - center.x);
        gltf.scene.position.y += (gltf.scene.position.y - center.y);
        gltf.scene.position.z += (gltf.scene.position.z - center.z);
    }

    public static clearScene(scene) {
        var toremove = [];
        scene.traverse(x => {
            // Skip base scene objects, helpers, and lights
            if (x.name === "baseScene" ||
                x.userData?.isHelper ||
                x instanceof THREE.Light ||
                x instanceof THREE.HemisphereLightHelper ||
                x instanceof THREE.DirectionalLightHelper) {
                return;
            }

            var object = scene.getObjectByName(x.name);
            if (object?.type !== 'Scene') {
                if (object) {
                    toremove.push(x);
                }
            }
        });

        for (var i = 0; i < toremove.length; i++) {
            var object = scene.getObjectByProperty('uuid', toremove[i].uuid);
            if (object) {
                scene.remove(toremove[i]);
            }
        }
    }

    public static getBoundingBox(object) {
        var box = new THREE.Box3().setFromObject(object);
        return box;
    }

    public static getObjectByUserDataProp(scene, key, value) {
        let foundObject = null;

        scene.traverse(function (child) {
            if (!(child instanceof THREE.Sprite) && child.userData[key] === value) {
                foundObject = child;
            }
        });

        return foundObject;
    }

    public static getRotationVectorByObjectNameAndFaceCenterIndex(scene: THREE.Scene, outputid: string, index: number, cadnode: THREE.Object3D): THREE.Vector3 | null {
        let object = ThreeUtils.getObjectByUserDataProp(scene, "outputid", outputid);

        let referencePoint = null;
        if (!object) {
            // First try to find in face centers
            referencePoint = cadnode.userData?.faceCenters?.find(fc => fc.index === index);
            if (!referencePoint) {
                // If not found in face centers, try corner points
                referencePoint = cadnode.userData?.cornerPoints?.find(cp => cp.index === index);
            }
            if (!referencePoint && cadnode.userData?.allReferencePoints) {
                // Fallback to combined reference points for compatibility
                referencePoint = cadnode.userData.allReferencePoints.find(rp => rp.index === index);
            }
            if (referencePoint) {
                object = cadnode;
            }
        }
        else {
            // First try to find in face centers
            referencePoint = object.userData.faceCenters?.find(fc => fc.index === index);
            if (!referencePoint) {
                // If not found in face centers, try corner points
                referencePoint = object.userData.cornerPoints?.find(cp => cp.index === index);
            }
            if (!referencePoint && object.userData?.allReferencePoints) {
                // Fallback to combined reference points for compatibility
                referencePoint = object.userData.allReferencePoints.find(rp => rp.index === index);
            }
        }

        if (referencePoint) {
            return referencePoint.normal;
        }

        return null;
    }



    public static getWorldVectorByObjectNameAndFaceCenterIndex(scene: THREE.Scene, outputid: string, index: number, cadnode: THREE.Object3D): THREE.Vector3 | null {
        // Find the object with the given outputid
        let object = ThreeUtils.getObjectByUserDataProp(scene, "outputid", outputid);

        let referencePoint = null;
        if (!object) {
            // First try to find in face centers
            referencePoint = cadnode.userData?.faceCenters?.find(fc => fc.index === index);
            if (!referencePoint) {
                // If not found in face centers, try corner points
                referencePoint = cadnode.userData?.cornerPoints?.find(cp => cp.index === index);
            }
            if (!referencePoint && cadnode.userData?.allReferencePoints) {
                // Fallback to combined reference points for compatibility
                referencePoint = cadnode.userData.allReferencePoints.find(rp => rp.index === index);
            }
            if (referencePoint) {
                object = cadnode;
            }
        }
        else {
            // First try to find in face centers
            referencePoint = object.userData.faceCenters?.find(fc => fc.index === index);
            if (!referencePoint) {
                // If not found in face centers, try corner points
                referencePoint = object.userData.cornerPoints?.find(cp => cp.index === index);
            }
            if (!referencePoint && object.userData?.allReferencePoints) {
                // Fallback to combined reference points for compatibility
                referencePoint = object.userData.allReferencePoints.find(rp => rp.index === index);
            }
        }

        if (!referencePoint) {
            console.warn(`Reference point with index ${index} not found for object ${outputid}`);
            return null;
        }

        // Convert the reference point position to world coordinates
        const localpos = new THREE.Vector3(
            referencePoint.position.x,
            referencePoint.position.y,
            referencePoint.position.z
        );
        // Create world position vector and inherit from parent node
        const worldPosition = new THREE.Vector3();

        // Convert local position to world position by applying parent object's matrix
        object.updateMatrixWorld();
        localpos.applyMatrix4(object.matrixWorld);
        worldPosition.copy(localpos);

        return worldPosition;
    }

    public static getLocalVectorByObjectNameAndFaceCenterIndex(object: THREE.Object3D, index: number, cadnode: THREE.Object3D) {
        let referencePoint = null;
        if (!object) {
            // First try to find in face centers
            referencePoint = cadnode.userData?.faceCenters?.find(fc => fc.index === index);
            if (!referencePoint) {
                // If not found in face centers, try corner points
                referencePoint = cadnode.userData?.cornerPoints?.find(cp => cp.index === index);
            }
            if (!referencePoint && cadnode.userData?.allReferencePoints) {
                // Fallback to combined reference points for compatibility
                referencePoint = cadnode.userData.allReferencePoints.find(rp => rp.index === index);
            }
            if (referencePoint) {
                object = cadnode;
            }
        }
        else {
            // First try to find in face centers
            referencePoint = object.userData.faceCenters?.find(fc => fc.index === index);
            if (!referencePoint) {
                // If not found in face centers, try corner points
                referencePoint = object.userData.cornerPoints?.find(cp => cp.index === index);
            }
            if (!referencePoint && object.userData?.allReferencePoints) {
                // Fallback to combined reference points for compatibility
                referencePoint = object.userData.allReferencePoints.find(rp => rp.index === index);
            }
        }

        if (!referencePoint) {
            console.warn(`Reference point with index ${index} not found`);
            return null;
        }

        // Convert the reference point position to local coordinates
        const localpos = new THREE.Vector3(
            referencePoint.position.x,
            referencePoint.position.y,
            referencePoint.position.z
        );

        return localpos;
    }

    public static getObjectByUserDataProps(scene, keys, values) {
        let foundObject = null;

        scene.traverse(function (child) {
            var match = true;
            for (let i = 0; i < keys.length; i++) {
                if (!child.userData.hasOwnProperty(keys[i])) {
                    match = false;
                    return;
                }
                if (child.userData[keys[i]] !== values[i]) {
                    return;
                } else {
                    console.log(child.userData[keys[i]], values[i]);
                }
            }
            foundObject = child;
        });

        return foundObject;
    }

    public static getBBox(subscene): THREE.Box3 {
        function getSizeFromObj(object) {
            if (object instanceof THREE.Mesh) {
                // If geometry can be obtained from object, do not traverse the children
                var geometry = object.geometry;
                geometry.computeBoundingBox();
                object.updateMatrixWorld();
                var boundingBox = geometry.boundingBox.clone();
                boundingBox.applyMatrix4(object.matrixWorld);
                return boundingBox;
            } else {
                // Fallback method as default
                object.updateMatrixWorld();
                console.log(new THREE.Box3().setFromObject(object));
                return new THREE.Box3().setFromObject(object).getSize(new THREE.Vector3());
            }
        }

        var bbox = { min: { x: Infinity, y: Infinity, z: Infinity }, max: { x: -Infinity, y: -Infinity, z: -Infinity } };

        if (!subscene) return;

        subscene.traverse((child) => {

            if (child.userData?.isHelper) {
                return;
            }
            if ((child.type === "Object3D" || child.type == "Mesh") && (child.userData?.type !== "refpoint" && child.userData?.type !== "refnormal")) { // fenster: Object3D. regal: mesh
                if (child.visible) {

                    // var b = new THREE.Box3().setFromObject(child);
                    var b = getSizeFromObj(child);
                    if (b.min.x < bbox.min.x) bbox.min.x = b.min.x;
                    if (b.min.y < bbox.min.y) bbox.min.y = b.min.y;
                    if (b.min.z < bbox.min.z) bbox.min.z = b.min.z;
                    if (b.max.x > bbox.max.x) bbox.max.x = b.max.x;
                    if (b.max.y > bbox.max.y) bbox.max.y = b.max.y;
                    if (b.max.z > bbox.max.z) bbox.max.z = b.max.z;
                }

            }
        });

        var bb = new THREE.Box3(new THREE.Vector3(bbox.min.x, bbox.min.y, bbox.min.z), new THREE.Vector3(bbox.max.x, bbox.max.y, bbox.max.z));

        return bb;
    }

    HierarchyDisposal(showLogging = false) {
        const bag = []
        const ignoreKeys = [
            '_super',
            'parent'
        ]

        const dispose = (obj, ondone) => {
            const id = obj.uuid
            const name = obj.name || id || obj
            if (bag.includes(id)) return
            if (showLogging) console.log('calling dispose on', name)

            for (var key in obj) {
                const childObj = obj[key]
                if (
                    obj.hasOwnProperty(key) &&
                    !ignoreKeys.includes(key) &&
                    childObj &&
                    typeof childObj === 'object'
                ) dispose(childObj, false)
            }
            if (typeof obj.dispose === 'function' && obj.uuid) {
                if (showLogging) console.log('disposing of', name)
                obj.dispose()
                bag.push(id)
            }
            if (typeof ondone === 'function') ondone(bag)
        }

        return dispose
    }

    // Add this helper method to create the edit button sprite
    public static createEditButtonSprite(): THREE.Sprite {
        const canvas = document.createElement('canvas');
        canvas.width = 1024;
        canvas.height = 256;
        const context = canvas.getContext('2d');

        // Clear canvas
        context.clearRect(0, 0, canvas.width, canvas.height);

        // Draw rounded rectangle background
        const radius = 20;
        context.beginPath();
        context.moveTo(radius, 0);
        context.lineTo(canvas.width - radius, 0);
        context.quadraticCurveTo(canvas.width, 0, canvas.width, radius);
        context.lineTo(canvas.width, canvas.height - radius);
        context.quadraticCurveTo(canvas.width, canvas.height, canvas.width - radius, canvas.height);
        context.lineTo(radius, canvas.height);
        context.quadraticCurveTo(0, canvas.height, 0, canvas.height - radius);
        context.lineTo(0, radius);
        context.quadraticCurveTo(0, 0, radius, 0);
        context.closePath();

        // Create gradient
        const gradient = context.createLinearGradient(0, 0, 0, canvas.height);
        gradient.addColorStop(0, '#dd00ff');
        gradient.addColorStop(1, '#dd00ff');

        context.fillStyle = gradient;
        context.fill();

        // Add text
        context.fillStyle = 'white';
        context.font = 'bold 164px Arial';
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillText('EDIT', canvas.width / 2, canvas.height / 2);

        // Create sprite
        const texture = new THREE.CanvasTexture(canvas);
        const spriteMaterial = new THREE.SpriteMaterial({
            map: texture,
            transparent: true,
            depthTest: false,
            depthWrite: false
        });

        const sprite = new THREE.Sprite(spriteMaterial);
        sprite.scale.set(80, 20, 1);

        return sprite;
    }

    // Add this helper method to create the delete button sprite
    public static createDeleteButtonSprite(): THREE.Sprite {
        const canvas = document.createElement('canvas');
        canvas.width = 256;
        canvas.height = 256;
        const context = canvas.getContext('2d');

        // Clear canvas
        context.clearRect(0, 0, canvas.width, canvas.height);

        const centerX = canvas.width / 2;
        const centerY = canvas.height / 2;
        const radius = canvas.width / 2 - 5;

        // Draw circle background
        context.beginPath();
        context.arc(centerX, centerY, radius, 0, 2 * Math.PI);

        // Create gradient
        const gradient = context.createRadialGradient(centerX, centerY, 0, centerX, centerY, radius);
        gradient.addColorStop(0, '#ff4444');
        gradient.addColorStop(1, '#cc0000');

        context.fillStyle = gradient;
        context.fill();

        // Add border
        context.strokeStyle = 'rgba(0, 0, 0, 0.8)';
        context.lineWidth = 6;
        context.stroke();

        // Draw trash icon
        context.fillStyle = 'white';
        context.strokeStyle = 'white';
        context.lineWidth = 8;

        // Trash can body
        const bodyWidth = radius * 0.6;
        const bodyHeight = radius * 0.8;
        const bodyX = centerX - bodyWidth / 2;
        const bodyY = centerY - bodyHeight / 2 + radius * 0.1;

        context.fillRect(bodyX, bodyY, bodyWidth, bodyHeight);

        // Trash can lid
        const lidWidth = bodyWidth * 1.2;
        const lidHeight = radius * 0.15;
        const lidX = centerX - lidWidth / 2;
        const lidY = bodyY - lidHeight;

        context.fillRect(lidX, lidY, lidWidth, lidHeight);

        // Trash can handle
        const handleWidth = bodyWidth * 0.4;
        const handleHeight = radius * 0.1;
        const handleX = centerX - handleWidth / 2;
        const handleY = lidY - handleHeight * 1.5;

        context.fillRect(handleX, handleY, handleWidth, handleHeight);

        // Vertical lines on trash can body
        context.lineWidth = 4;
        const lineSpacing = bodyWidth / 4;
        for (let i = 1; i < 4; i++) {
            const lineX = bodyX + i * lineSpacing;
            context.beginPath();
            context.moveTo(lineX, bodyY + bodyHeight * 0.2);
            context.lineTo(lineX, bodyY + bodyHeight * 0.8);
            context.stroke();
        }

        // Create sprite
        const texture = new THREE.CanvasTexture(canvas);
        const spriteMaterial = new THREE.SpriteMaterial({
            map: texture,
            transparent: true,
            depthTest: false,
            depthWrite: false
        });

        const sprite = new THREE.Sprite(spriteMaterial);
        sprite.scale.set(30, 30, 1);
        sprite.userData.isDeleteButton = true;

        return sprite;
    }

    public static create3DMarker(box: THREE.Box3, length: number, width: number, gap: number, color: any) {
        var wgroup: THREE.Group;
        var mat = new THREE.MeshPhongMaterial({ color: color });//, transparent: false, opacity: 1, specular: 0xf08a00, emissive: 0xf08a00, shininess: 0 })
        var w = Math.abs(box.max.x - box.min.x);
        var h = Math.abs(box.max.y - box.min.y);
        var d = Math.abs(box.max.z - box.min.z);
        // get mininum w h d
        var min = Math.min(w, h, d);

        var length = min / 4;
        var width = 2;

        wgroup = new THREE.Group();

        var x1 = new THREE.BoxGeometry(length, width, width); var mx1 = new THREE.Mesh(x1, mat); wgroup.add(mx1);
        mx1.position.set(box.min.x + length / 2, box.min.y, box.min.z);
        var y1 = new THREE.BoxGeometry(width, length, width); var my1 = new THREE.Mesh(y1, mat); wgroup.add(my1);
        my1.position.set(box.min.x, box.min.y + length / 2, box.min.z);
        var z1 = new THREE.BoxGeometry(width, width, length); var mz1 = new THREE.Mesh(z1, mat); wgroup.add(mz1);
        mz1.position.set(box.min.x, box.min.y, box.min.z + length / 2);

        var x2 = new THREE.BoxGeometry(length, width, width); var mx2 = new THREE.Mesh(x2, mat); wgroup.add(mx2);
        mx2.position.set(box.max.x - length / 2, box.min.y, box.min.z);
        var y2 = new THREE.BoxGeometry(width, length, width); var my2 = new THREE.Mesh(y2, mat); wgroup.add(my2);
        my2.position.set(box.max.x, box.min.y + length / 2, box.min.z);
        var z2 = new THREE.BoxGeometry(width, width, length); var mz2 = new THREE.Mesh(z2, mat); wgroup.add(mz2);
        mz2.position.set(box.max.x, box.min.y, box.min.z + length / 2);

        var x3 = new THREE.BoxGeometry(length, width, width); var mx3 = new THREE.Mesh(x3, mat); wgroup.add(mx3);
        mx3.position.set(box.min.x + length / 2, box.max.y, box.min.z);
        var y3 = new THREE.BoxGeometry(width, length, width); var my3 = new THREE.Mesh(y3, mat); wgroup.add(my3);
        my3.position.set(box.min.x, box.max.y - length / 2, box.min.z);
        var z3 = new THREE.BoxGeometry(width, width, length); var mz3 = new THREE.Mesh(z3, mat); wgroup.add(mz3);
        mz3.position.set(box.min.x, box.max.y, box.min.z + length / 2);

        var x4 = new THREE.BoxGeometry(length, width, width); var mx4 = new THREE.Mesh(x4, mat); wgroup.add(mx4);
        mx4.position.set(box.max.x - length / 2, box.max.y, box.min.z);
        var y4 = new THREE.BoxGeometry(width, length, width); var my4 = new THREE.Mesh(y4, mat); wgroup.add(my4);
        my4.position.set(box.max.x, box.max.y - length / 2, box.min.z);
        var z4 = new THREE.BoxGeometry(width, width, length); var mz4 = new THREE.Mesh(z4, mat); wgroup.add(mz4);
        mz4.position.set(box.max.x, box.max.y, box.min.z + length / 2);

        // obenlinkshinten
        var x5 = new THREE.BoxGeometry(length, width, width); var mx5 = new THREE.Mesh(x5, mat); wgroup.add(mx5);
        mx5.position.set(box.min.x + length / 2, box.min.y, box.max.z);
        var y5 = new THREE.BoxGeometry(width, length, width); var my5 = new THREE.Mesh(y5, mat); wgroup.add(my5);
        my5.position.set(box.min.x, box.min.y + length / 2, box.max.z);
        var z5 = new THREE.BoxGeometry(width, width, length); var mz5 = new THREE.Mesh(z5, mat); wgroup.add(mz5);
        mz5.position.set(box.min.x, box.min.y, box.max.z - length / 2);

        var x6 = new THREE.BoxGeometry(length, width, width); var mx6 = new THREE.Mesh(x6, mat); wgroup.add(mx6);
        mx6.position.set(box.max.x - length / 2, box.min.y, box.max.z);
        var y6 = new THREE.BoxGeometry(width, length, width); var my6 = new THREE.Mesh(y6, mat); wgroup.add(my6);
        my6.position.set(box.max.x, box.min.y + length / 2, box.max.z);
        var z6 = new THREE.BoxGeometry(width, width, length); var mz6 = new THREE.Mesh(z6, mat); wgroup.add(mz6);
        mz6.position.set(box.max.x, box.min.y, box.max.z - length / 2);

        var x7 = new THREE.BoxGeometry(length, width, width); var mx7 = new THREE.Mesh(x7, mat); wgroup.add(mx7);
        mx7.position.set(box.min.x + length / 2, box.max.y, box.max.z);
        var y7 = new THREE.BoxGeometry(width, length, width); var my7 = new THREE.Mesh(y7, mat); wgroup.add(my7);
        my7.position.set(box.min.x, box.max.y - length / 2, box.max.z);
        var z7 = new THREE.BoxGeometry(width, width, length); var mz7 = new THREE.Mesh(z7, mat); wgroup.add(mz7);
        mz7.position.set(box.min.x, box.max.y, box.max.z - length / 2);

        var x8 = new THREE.BoxGeometry(length, width, width); var mx8 = new THREE.Mesh(x8, mat); wgroup.add(mx8);
        mx8.position.set(box.max.x - length / 2, box.max.y, box.max.z);
        var y8 = new THREE.BoxGeometry(width, length, width); var my8 = new THREE.Mesh(y8, mat); wgroup.add(my8);
        my8.position.set(box.max.x, box.max.y - length / 2, box.max.z);
        var z8 = new THREE.BoxGeometry(width, width, length); var mz8 = new THREE.Mesh(z8, mat); wgroup.add(mz8);
        mz8.position.set(box.max.x, box.max.y, box.max.z - length / 2);

        return wgroup;
    }

    public static isGltfNode(node: THREE.Object3D): boolean {
        let curnode: THREE.Object3D | null = node;
        while (curnode) {
            if (curnode.userData?.typ == "gltf") return true;
            curnode = curnode.parent;
        }
        return false;
    }

    public static gltfNodeBox(node: THREE.Object3D | null, scene: THREE.Scene): THREE.Box3 | null {
        if (scene.getObjectByName('highlightNode')) {
            scene.remove(scene.getObjectByName('highlightNode')!);
        }

        if (node) {
            const bbox = new THREE.Box3().setFromObject(node);

            const highlightNode = new THREE.BoxHelper(node, 0xff0000);
            highlightNode.name = 'highlightNode';
            highlightNode.geometry.computeBoundingBox();
            highlightNode.material.transparent = false;
            highlightNode.material.opacity = 1;
            highlightNode.material.depthTest = false;
            highlightNode.material.depthWrite = false;

            highlightNode.renderOrder = 99999;
            highlightNode.onBeforeRender = function (renderer) { renderer.clearDepth(); };

            scene.add(highlightNode);
            return bbox;
        }

        return null;
    }

    /**
     * Zooms the camera to fit all visible non-helper objects in the scene.
     * @param scene The main THREE.Scene object.
     * @param camera The THREE.Camera object.
     * @param controls The OrbitControls object.
     * @param baseScene The BaseScene object containing helper objects.
     * @param zoomOffsetFactor Optional factor to adjust the zoom distance (default: 2.5).
     */
    public static zoomAllVisible(scene: THREE.Scene, camera: THREE.Camera, controls: any, baseScene: BaseScene, zoomOffsetFactor: number = 2.5) {
        const visibleObjects: THREE.Object3D[] = [];

        const findVisibleObjects = (object: THREE.Object3D) => {
            if (!object.visible) return;
            if (object.userData.isHelper || object.name === 'baseScene') return;
            if (object === baseScene.axes ||
                object === baseScene.grid ||
                object === baseScene.grass ||
                (baseScene.dirLabels && baseScene.dirLabels.some(label => label === object)) ||
                object === baseScene.dirLightHelper ||
                object === baseScene.hemiLightHelper) {
                return;
            }

            if (object instanceof THREE.Mesh || object instanceof THREE.Line) {
                visibleObjects.push(object);
            }

            object.children.forEach(child => findVisibleObjects(child));
        };

        findVisibleObjects(scene);

        if (visibleObjects.length === 0) {
            console.warn('No visible objects found to zoom to');
            return;
        }

        ThreeUtils.zoomObject(camera, controls, visibleObjects, zoomOffsetFactor);
    }
}

export { ThreeUtils };